import { DecimalPipe } from '@angular/common';
import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'fixedNumber',
    standalone: false
})
export class FixedNumberPipe implements PipeTransform {

  private decimalPipe: DecimalPipe;

  constructor(@Inject(LOCALE_ID) private locale: string) {
    this.decimalPipe = new DecimalPipe(locale);
  }

  transform(value: number, ...args: unknown[]): unknown {
    if(typeof value !== 'number') {
      return value;
    }

    let fractionDigits = 2;
    if(args.length > 0 && typeof args[0] === 'number') {
      fractionDigits = args[0];
    }

    return this.decimalPipe.transform(value, `.${fractionDigits}-${fractionDigits}`)
  }

}
